import React from 'react'
import { useNewTranslation } from 'hooks'
import { BaseEditorContainer, EditorContentCardContainer } from '../PredefinedTaskEditor/styles'
import { Header } from '../Shared'
import styled from 'particles/themes/styled'
import Fields from 'components/Shared/Fields'
import { useSelector } from 'react-redux'
import { CAMPAIGN_STATUS_ENUM, selectEditingCampaign } from 'state/campaigns'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'
interface RegistrationScheduleProps {
    className?: string
    taskUuid?: string
}

const RegistrationSchedule: React.FC<RegistrationScheduleProps> = ({ className, taskUuid }) => {
    const [t] = useNewTranslation()
    const campaign = useSelector(selectEditingCampaign)

    return (
        <BaseEditorContainer className={className}>
            <EditorContentCardContainer>
                <Header title={t('campaignEditor.createTask.scheduleRegistrationPageTitle')} />
                <div className="section">
                    {campaign && (
                        <CampaignEditorInputFieldContainer isEditDeadline launchFieldEditable>
                            <Fields.DatePickerField
                                name="time_window.start"
                                isRequired
                                title={t('general.information.startDate')}
                                subtitle={t(
                                    'campaignEditor.createTask.scheduleRegistration.enterStartDateRegistrationSubtext',
                                )}
                                readOnlyForPastDate={Boolean(campaign && campaign.status === CAMPAIGN_STATUS_ENUM.LIVE)}
                                country={campaign.country}
                                identifier={`${taskUuid}_registration_${fieldIdentifiers.start}`}
                            />
                            <Fields.DatePickerField
                                name="time_window.end"
                                isRequired
                                title={t('general.information.endDate')}
                                subtitle={t(
                                    'campaignEditor.createTask.scheduleRegistration.enterEndDateRegistrationSubtext',
                                )}
                                country={campaign.country}
                                identifier={`${taskUuid}_registration_${fieldIdentifiers.end}`}
                            />
                        </CampaignEditorInputFieldContainer>
                    )}
                    <CampaignEditorInputFieldContainer>
                        <Fields.NumberInputField
                            name="approval_expiration_days"
                            width="133px"
                            title={t('campaignEditor.createTask.enterInvitationExpiryHeader')}
                            subtitle={t('campaignEditor.createTask.enterInvitationExpirySubtext')}
                            placeholder={'0'}
                            isRequired
                            identifier={`${taskUuid}_registration_${fieldIdentifiers.invitationExpiry}`}
                        />
                    </CampaignEditorInputFieldContainer>
                </div>
            </EditorContentCardContainer>
        </BaseEditorContainer>
    )
}

export default styled(RegistrationSchedule)`
    min-height: 100%;
    height: fit-content;
    .section {
        .divider {
            margin: 0;
        }
    }
`
